/* eslint-disable promise/no-nesting */
/* eslint-disable promise/always-return */
import Config from '@/config'
import socket from '@/socket'
import Util from '@/util'
import * as Sentry from '@sentry/vue'
import { getMessageSubscriber } from '@/websocket/subscribers/legacy/main.websocket.subscriber'
import { getMessageSubscriber as getNextBackMessageSubscriber } from '@/store/modules/nextback/nextback.websocket.subscriber'
import store from '@/store'
import AudienceApi from '../api/audience'

export default {
  async handleInitSocket(res, editor) {
    editor.handleDataQuestions(res.body.presentation)

    if (editor.isConnectSocket) {
      // eslint-disable-next-line promise/catch-or-return
      try {
        const dataPresentation = await AudienceApi.getAudienceDataCDN(editor.uniqueAccessCode)
        if (!dataPresentation.body.presenting) {
          editor._handleDataReconnect(dataPresentation)
          return
        }

        if (!dataPresentation.body.slideActiveCacheUrl) {
          return
        }

        const urlCdn = dataPresentation.body.slideActiveCacheUrl

        // eslint-disable-next-line promise/no-nesting
        editor.$http.get(urlCdn)
          .then((res) => {
            res.body = editor.tryParseBody(res.bodyText, dataPresentation.body.id)
            res.body.presentation = dataPresentation.body
            editor._handleDataReconnect(res)
          })
          .catch((err) => {
            // eslint-disable-next-line promise/catch-or-return
            editor.$http.get(Config.api.getPresentation + editor.uniqueAccessCode)
              .then((dataUnhandle) => {
                editor._handleDataReconnect(dataUnhandle)
              })

            if (Sentry && err.status) {
              err.from = 'Audience reconnect'
              Sentry.captureException(JSON.stringify(err))
            }
          })
      } catch (err) {
        Sentry.captureException(err)
        if (err.status === 400) {
          editor.$router.push({
            name: 'home',
            query: { error: true },
          })
        }
      }

      editor.$store.state.socketDisconnect = false
      Util.mixpanelTrack(
        'System Status',
        'Connection is back',
        editor.$store.state.presentation.id,
        { nonInteraction: true },
      )

      return
    }

    socket.subscribe(editor.uniqueAccessCode.toLowerCase(), (doc) => {
      let messageSubscriber
      if (editor.$store.getters['featureToggles/canUseNewChangeSlideMechanism']) {
        messageSubscriber = getNextBackMessageSubscriber(doc.type)
      } else {
        messageSubscriber = getMessageSubscriber(doc.type)
      }
      if (messageSubscriber && typeof messageSubscriber === 'function') {
        messageSubscriber(doc, editor)
      }
      store.dispatch('websocket/newMessage', doc)
    })

    editor.isConnectSocket = true
    const self = editor
    socket.getSocket().on('disconnect', () => {
      self.$store.state.socketDisconnect = true
      Util.mixpanelTrack(
        'System Status',
        'Notify poor connection',
        self.$store.state.presentation.id,
        { nonInteraction: true },
      )
    })
  },
}
